export default {
      id: "pepsi-usage",
      viewBox: "0 0 185 44",
      url: __webpack_public_path__ + "sprite.svg#pepsi-usage",
      toString: function () {
        return this.url;
      }
    }